// extracted by mini-css-extract-plugin
export default {"icon":"CustomIcon_icon__Lbgoa","notification":"CustomIcon_notification__ggSYy"};